import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'app-dashboard-skeleton',
  standalone: true,
  imports: [CommonModule, SkeletonModule],
  templateUrl: './dashboard-skeleton.component.html',
  styleUrl: './dashboard-skeleton.component.scss'
})
export class DashboardSkeletonComponent {
  quickActionCells = Array.from({ length: 6 });
  checklistRows = Array.from({ length: 6 });
  statBoxes = Array.from({ length: 4 });
  promoCards = Array.from({ length: 3 });
}
